import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CardComponent } from "../../components/card/card.component";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InfoProductModalComponent } from '../../components/info-product-modal/info-product-modal.component';
import { DataService } from '../../../../services/dashboard/data.service';
import { NtMedicineInterface } from '../../../../shared/interfaces/nt-medicine.interface';
import { Router } from '@angular/router';
import { SkeletonMedicineCardComponent } from "../../components/skeleton-medicine-card/skeleton-medicine-card.component";
import { NoMedicinesNoteComponent } from "../../components/no-medicines-note/no-medicines-note.component";
import { InstanceOptions, Tooltip, TooltipOptions } from 'flowbite';

@Component({
  selector: 'app-farmaco',
  standalone: true,
  imports: [CardComponent, CommonModule, FormsModule, InfoProductModalComponent, SkeletonMedicineCardComponent, NoMedicinesNoteComponent],
  templateUrl: './farmaco.component.html',
  styleUrl: './farmaco.component.css'
})
export class FarmacoComponent implements OnInit {
  farmacoFiltered: string = '';
  allMedicines: NtMedicineInterface[] = [];  // Backup per il reset
  medicines: NtMedicineInterface[] = [];     // Lista filtrabile
  modalFarmacoOpen: boolean = false
  idFarmaco: number = 0;
  idFarmacoToDashboard: number = 0;
  farmacoToModal: any;
  companyIdToSend: number = 0;
  showSkeleton: boolean = true;
  noMedicinesFound: boolean = false;
  private tooltipsInitialized = false;



  selectedTab: 'inLancio' | 'sulMercato' = 'inLancio';

  // Default brand info in case of missing data
  DEFAULT_MEDICINE_BRAND = {
    font: { title: 'Arial, sans-serif', subtitle: 'Helvetica, sans-serif' },
    colors: { title: '#141F58', subtitle: '#00CEBC', background: '#FFFFFF' },
    logo: { url: '', altText: 'Logo' },
  };

  constructor (private dataService: DataService, private router: Router) { }

  ngOnInit () {
    sessionStorage.setItem("level", "Farmaco")
    sessionStorage.setItem("medicineId", "")
    sessionStorage.setItem("solution", "Territorial");
    const companyIdString = sessionStorage.getItem('companyId');
    const companyId = companyIdString ? parseInt(companyIdString, 10) : null;
    this.companyIdToSend = companyId!;

    window.dispatchEvent(new CustomEvent('inWhichPage', { detail: "FARMACO" }));


    if (companyId !== null) {
      this.showSkeleton = true;

      this.dataService.getMedicinesByCompanyId(companyId).subscribe({
        next: medicines => {
          this.allMedicines = medicines;
          if (medicines.length === 0) {
            this.noMedicinesFound = true;
          } else {
            this.noMedicinesFound = false;
            this.filterByLaunchStatus(false);
          }
          this.showSkeleton = false;
        },
        error: err => {
          this.allMedicines = [];
          this.noMedicinesFound = true;
          this.showSkeleton = false;
        }
      });

    } else {
      console.error('Invalid companyId: null or not a number');
      this.allMedicines = [];
      this.noMedicinesFound = true;
      this.showSkeleton = false;
    }

    this.tooltipConfig();
  }

  ngAfterViewChecked (): void {
    const triggers = document.querySelectorAll('.tooltip-trigger');
    const contents = document.querySelectorAll('.tooltip-content');

    // if not visible tooltips reset the flag
    if (triggers.length === 0 || contents.length === 0) {
      this.tooltipsInitialized = false;
    }

    if (!this.tooltipsInitialized && triggers.length && contents.length) {
      this.tooltipConfig();
      this.tooltipsInitialized = true;
    }
  }

  tooltipConfig (): void {
    const triggerElements = document.querySelectorAll<HTMLElement>('.tooltip-trigger');
    const contentElements = document.querySelectorAll<HTMLElement>('.tooltip-content');

    triggerElements.forEach((triggerEl, index) => {
      const contentEl = contentElements[index];

      if (contentEl && triggerEl) {
        const options: TooltipOptions = {
          placement: 'top',
          triggerType: 'hover',
          onHide: () => console.log('tooltip is hidden'),
          onShow: () => console.log('tooltip is shown'),
          onToggle: () => console.log('tooltip is toggled'),
        };

        const instanceOptions: InstanceOptions = {
          id: `tooltip-${index}`,
          override: true,
        };

        new Tooltip(contentEl, triggerEl, options, instanceOptions);
      }
    });
  }



  filterByLaunchStatus (isLaunched: boolean): void {
    this.medicines = this.allMedicines.filter(medicine => medicine.launched === isLaunched);
    //this.medicines=[]// HERE TO SIMULATE NO MEDICINE

    if (isLaunched && this.medicines.length > 0) {
      this.noMedicinesFound = false;
    } else if (isLaunched && this.medicines.length == 0) {
      this.noMedicinesFound = true;
    }
    if (!isLaunched) {
      this.noMedicinesFound = false;
    }
  }

  filterMedicines (): void {
    if (this.farmacoFiltered.trim() === "") {
      this.medicines = this.allMedicines.filter(medicine => medicine.launched === (this.selectedTab === 'sulMercato'));
    } else {
      this.medicines = this.allMedicines.filter(medicine =>
        medicine.businessName.toLowerCase().includes(this.farmacoFiltered.toLowerCase()) &&
        medicine.launched === (this.selectedTab === 'sulMercato')
      );
    }
  }


  selectTab (tab: 'inLancio' | 'sulMercato') {
    this.selectedTab = tab;
    this.filterByLaunchStatus(tab === 'sulMercato');
  }

  openModalByIndex (id: number) {
    const farmacoToFind = this.allMedicines.find(med => med.id === id);
    this.farmacoToModal = farmacoToFind;

    this.idFarmaco = id;
    this.modalFarmacoOpen = true;
    document.body.style.overflow = 'hidden';
    document.body.style.width = '100%';

  }


  goToDashboard (idForDashboard: number) {
    this.dataService.userChosenFarmaco = true;
    this.idFarmacoToDashboard = idForDashboard;

    const brandMedicineInfo = this.medicines.find(med => med.id === idForDashboard);
    const merged = this.normalizeBrandInfo(brandMedicineInfo?.medicineBrandInfo);

    sessionStorage.setItem('brandMedicine', JSON.stringify(merged));

    sessionStorage.setItem('medicineId', this.idFarmacoToDashboard.toString());
    this.router.navigate(['/dashboard/territorial/national', this.idFarmacoToDashboard]);
  }

  //Helper to replace null/undefined/"" with a default
  val = (v: unknown, d: string) => typeof v === 'string' ? (v.trim() || d) : (v ?? d);

  //Normalize function for brandMedicineInfo
  normalizeBrandInfo (src: any) {
    const b = src ?? {};
    return {
      font: {
        title: this.val(b.font?.title, this.DEFAULT_MEDICINE_BRAND.font.title),
        subtitle: this.val(b.font?.subtitle, this.DEFAULT_MEDICINE_BRAND.font.subtitle),
      },
      colors: {
        title: this.val(b.colors?.title, this.DEFAULT_MEDICINE_BRAND.colors.title),
        subtitle: this.val(b.colors?.subtitle, this.DEFAULT_MEDICINE_BRAND.colors.subtitle),
        background: this.val(b.colors?.background, this.DEFAULT_MEDICINE_BRAND.colors.background),
      },
      // allow empty url, but keep a sensible altText
      logo: {
        url: b.logo?.url ?? '',
        altText: this.val(b.logo?.altText, this.DEFAULT_MEDICINE_BRAND.logo.altText),
      },
    };
  }


  closeModal () {
    this.modalFarmacoOpen = false;
    document.body.style.overflow = '';
    document.body.style.width = '';
  }

}
